// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/calm-clinical-badge.svg';

export const CalmClinicalBadge = ({ ...props }: SvgIconProps) => {
    return (
        <SvgIcon
            data-testid="Calm Clinical Badge"
            component={Svg}
            inheritViewBox
            {...props}
        />
    );
};
